module.exports = {
    "metadata": {
        "name": "Dabble Lab",
        "short_name": "dabble lab",
        "description": "Tutorials and templates for creating Alexa skills, Google Actions, and Twilio Autopilot bots.",
        "language": "en",
        "url": "http://localhost",
        "pathPrefix": "/dabblelab-documentation-site",
        "gaTrackingId": null,
        "siteImage": null,
        "favicon": "/assets/favicon.png",
        "themeColor": "#ff0000"
    },
    "header": {
        "logo": "/assets/code.svg",
        "logoLink": "/",
        "helpUrl": "",
        "links": [
            {
                "text": "DEMO",
                "link": "/demo",
                "external": false
            },
            {
                "text": "TEMPLATES",
                "link": "/templates",
                "external": false
            },
            {
                "text": "COURSES",
                "link": "/courses",
                "external": false
            }
        ],
        "enabled": true
    },
    "sidebar": {
        "enabled": true,
        "ignoreIndex": false,
        "forcedNavOrder": [],
        "expanded": [],
        "groups": [
            {
                "order": 1,
                "path": "/training",
                "title": "Technical Training"
            },
            {
                "order": 2,
                "path": "/tools",
                "title": "Developer Tools"
            },
            {
                "order": 3,
                "path": "/services",
                "title": "Support Services"
            },
            {
                "order": 4,
                "path": "/editing",
                "title": ":writing_hand: Editing Content"
            },
            {
                "order": 5,
                "path": "/deployment",
                "title": ":rocket: Deployment"
            },
            {
                "order": 6,
                "path": "/developing",
                "title": ":computer: Developing"
            }
        ],
        "links": [
            {
                "text": "Visit YouTube channel",
                "link": "https://www.youtube.com/dabblelab"
            },
            {
                "text": "Visit GitHub",
                "link": "https://github.com/dabblelab"
            }
        ],
        "poweredBy": {}
    },
    "pwa": {
        "manifest": {
            "name": "Dabble Lab",
            "short_name": "dabblelab",
            "start_url": "/",
            "background_color": "#6b37bf",
            "theme_color": "#6b37bf",
            "display": "standalone",
            "crossOrigin": "anonymous",
            "icon": "static/assets/favicon.png",
            "description": "Tutorials and templates for creating Alexa skills, Google Actions, and Twilio Autopilot bots.",
            "cache_busting_mode": "none",
            "include_favicon": false,
            "lang": "en"
        },
        "enabled": true
    },
    "social": {
        "facebook": "",
        "github": "https://github.com/dabblelab",
        "gitlab": "",
        "instagram": "",
        "linkedin": "https://www.linkedin.com/company/dabblelab",
        "mail": "",
        "gmail": "",
        "slack": "",
        "twich": "",
        "twitter": "https://twitter.com/dabblelab",
        "youtube": ""
    },
    "features": {
        "editOnRepo": {
            "editable": true,
            "location": "https://github.com/dabblelab/dabblelab-documentation-site",
            "type": "github"
        },
        "search": {
            "enabled": true,
            "indexName": "docs",
            "algoliaAppId": null,
            "algoliaSearchKey": null,
            "algoliaAdminKey": null,
            "excerptSize": 8000,
            "engine": "algolia",
            "placeholder": "Search",
            "startComponent": "input",
            "debounceTime": 380,
            "snippetLength": 23,
            "hitsPerPage": 10,
            "showStats": true,
            "localSearchEngine": {
                "encode": "advanced",
                "tokenize": "full",
                "threshold": 2,
                "resolution": 30,
                "depth": 20
            },
            "pagination": {
                "enabled": true,
                "totalPages": 10,
                "showNext": true,
                "showPrevious": true
            }
        },
        "toc": {
            "show": true,
            "depth": 4
        },
        "previousNext": {
            "enabled": true,
            "arrowKeyNavigation": true
        },
        "scrollTop": true,
        "showMetadata": true,
        "propagateNetlifyEnv": true,
        "pageProgress": {
            "enabled": true,
            "excludePaths": [
                "/"
            ],
            "height": 3,
            "prependToBody": false,
            "color": "#A05EB5",
            "includePaths": [
                "/configuration/settingup/features"
            ]
        },
        "mermaid": {
            "language": "mermaid",
            "theme": "dark",
            "options": {},
            "width": 400,
            "height": 300
        },
        "rss": {
            "enabled": false,
            "showIcon": false,
            "title": "Dabble Lab",
            "copyright": "2020 Dabble Lab",
            "webMaster": "Dabble Lab",
            "managingEditor": "Dabble Lab",
            "categories": [
                "Amazon Alexa",
                "Twilio Autopilot"
            ],
            "ttl": 60,
            "matchRegex": "^/",
            "outputPath": "/rss.xml",
            "generator": "boogi"
        },
        "darkMode": {
            "enabled": false,
            "default": false
        },
        "publishDraft": false,
        "fullScreenMode": {
            "enabled": true,
            "hideHeader": true,
            "hideToc": true,
            "hideSidebar": true
        }
    }
};